import React from 'react';
import { withTranslation } from 'react-i18next';
import { searchMatchedTextValue } from '../../../utils/common';
import RenderWsRow from '../renderWsRow';

class WorkstreamListPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wsListFull: [],
      wsListFullData: [],
      wsListFullArr: [],
      wsListFullArrCp: [],
    };
    this.searchWorkstream = this.searchWorkstream.bind(this);
    this.renderWs = this.renderWs.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const { meetingOwner } = this.props;
    $.ajax({
      url: `${wbConfig.baseUrl}/activity/getWorkStreamDetailsForMeeting`,
      type: 'get',
      data: { meetingOwner },
    })
      .done((response) => {
        const wsdata = response.data;
        const wsListFullArr = [];
        if (wsdata) {
          Object.keys(wsdata).map((it) => {
            wsdata[it] != null && typeof wsdata[it] !== 'undefined' && Object.keys(wsdata[it]).map((ti) => {
              if (it == 'teams' && wsdata[it][ti].ws) {
                Object.keys(wsdata[it][ti].ws).map((wsArr) => {
                  wsListFullArr.push(wsdata[it][ti].ws[wsArr]);
                });
              } else {
                wsListFullArr.push(wsdata[it][ti]);
              }
            });
          });
        }
        _this.setState({
          wsListFull: wsdata,
          wsListFullData: wsdata,
          wsListFullArr,
        });
      });
  }

  searchWorkstream(e) {
    const _this = this;
    let searchWs = e.target.value.trim();
    if (searchWs == '') {
      _this.setState({
        wsListFull: this.state.wsListFullData,
      });
    } else {
      searchWs = searchWs.toLowerCase();
      let wsListFullCp = [];
      const { wsListFullArr } = this.state;
      wsListFullCp = wsListFullArr.filter((item) => {
        if (searchWs) {
          const itemName = item.name.toLowerCase();
          let itemTeamName = '';
          if (typeof item.tname !== 'undefined') {
            itemTeamName = item.tname.toLowerCase();
          }
          return searchMatchedTextValue(itemName, searchWs) || searchMatchedTextValue(itemTeamName, searchWs);
        }
        return false;
      });
      const tempArrP = {};
      const tempArrS = {};
      const tempArrT = {};
      wsListFullCp.map((item) => {
        if (item.tid == '-1') {
          tempArrP[item.id] = item;
        } else if (item.tid == '-2') {
          tempArrS[item.id] = item;
        } else if (item.tid) {
          const wsL = [];
          wsListFullCp.map((i1) => {
            if (i1.tid == item.tid) {
              wsL.push(i1);
            }
          });
          const myMan = {};
          myMan.id = item.tid;
          myMan.owner = '';
          myMan.isAdmin = '';
          myMan.isComanager = '';
          myMan.name = item.tname;
          myMan.ws = wsL;
          tempArrT[item.tid] = myMan;
        }
      });
      const list = {};
      list.personal = tempArrP;
      list.sharedWs = tempArrS;
      list.teams = tempArrT;
      this.setState({ wsListFull: list });
    }
  }

  renderWs(item, key) {
    const { addWsPopup, t } = this.props;
    if (!item || typeof item === 'undefined' || !Object.keys(item).length) return null;
    if (key != 'teams') {
      let wsData_;
      if (key == 'personal') {
        wsData_ = {
          id: -1,
          name: t('Personal stream'),
          ws: item,
        };
      }
      if (key == 'sharedWs') {
        wsData_ = {
          id: -2,
          name: t('Shared stream'),
          ws: item,
        };
      }
      return (wsData_) ? <RenderWsRow key="`${item.id}_${item.name}`" wsData={wsData_} addWsPopup={addWsPopup} closeWsModelBox={this.props.closeWsModelBox} /> : '';
    }

    return item && typeof item !== 'undefined' && Object.keys(item).length && Object.keys(item) != null
      ? Object.entries(item).map(([key, value]) => <RenderWsRow key="`${item.id}_${item.name}`" wsData={value} addWsPopup={addWsPopup} closeWsModelBox={this.props.closeWsModelBox} />)
      : '';
  }

  render() {
    const { t } = this.props;
    return (
      <div id="meetingWsListId" className="meetingWsList meetingWsTop">
        <input className="meetingWsInput gbl-text-entry" placeholder={t('Type a workstream name or team name to search')} onChange={this.searchWorkstream} />
        <div>
          {
          Object.keys(this.state.wsListFull).length
            ? Object.entries(this.state.wsListFull).map(([key, value]) => this.renderWs(value, key))
            : ''
          }
        </div>
      </div>
    );
  }
}

export default withTranslation()(WorkstreamListPopup);
